'use strict';

var _ = require('lodash');
var StrategyRowDetailsController = function StrategyRowDetailsController($scope, strategiesService, serializeStrategyService, restangular) {
  $scope.rowDetailsStrategy = {};
  function showRowDetails(strategy) {
    var rowDetails = strategiesService.copyStrategy(strategy);
    $scope.rowDetailsStrategy = serializeStrategyService.parseStrategy(rowDetails);
  }
  function fetchRowDetails(strategy) {
    var rulesSearchAPI = restangular.one('rules').all('strategy');
    rulesSearchAPI.get('?filter=name=="' + encodeURIComponent(strategy.name) + '"').then(function (response) {
      showRowDetails(response.results[0]);
    });
  }
  function hasStrategyFullData(strategy) {
    return _.has(strategy, 'statements');
  }
  $scope.onStrategyDetailsDataChanged = function (strategy) {
    if (hasStrategyFullData(strategy)) {
      showRowDetails(strategy);
    } else {
      fetchRowDetails(strategy);
    }
  };
};
StrategyRowDetailsController.$inject = ['$scope', 'StrategiesService', 'SerializeStrategyService', 'Restangular'];
module.exports = StrategyRowDetailsController;